export const en = {
  navbar: {
    projects: 'Projects',
    carbonPackages: 'Credit Packages',
    retirements: 'Retirements',
    moreInfo: 'More Information',
    accessPlatform: 'Access Platform'
  },
  hero: {
    title: 'High Quality Carbon Credits for a New Planet.',
    subtitle: 'Together we will reduce atmospheric carbon dioxide levels through technology and support between companies and rural producers.',
    ctaButton: 'Get Started'
  },
  carbonAssets: {
    title: 'Credit Packages',
    subtitle: 'Explore our collection of verified and certified carbon credits, contributing to a more sustainable future.',
    viewDetails: 'View Details',
    wilderSocialCarbonDetails: 'Wilder Earth — Social Carbon',
    purchaseRequest: 'Request Purchase',
    loading: 'Loading assets...',
    error: 'Error loading assets',
    noAssets: 'No VERT ECOTECH SA project found.',
    standard: 'Standard',
    vintage: 'Vintage',
    projectType: 'Project Type',
    createdDate: 'Created Date',
    credits: 'credits',
    clickDetails: 'Click to view details',
    nameNotAvailable: 'Name not available',
    typeNotSpecified: 'Type not specified'
  },
  carbonRetirements: {
    eyebrow: 'Transparency',
    title: 'Retired Carbon Credits',
    subtitle: 'Track carbon credits that have been retired by VERT ECOTECH SA, contributing to emissions neutralization and sustainability projects.',
    statusRetired: 'Retired',
    projectType: 'Project type',
    createdDate: 'Date',
    beneficiary: 'Beneficiary',
    retiree: 'Retiree',
    purpose: 'Purpose',
    creditsRetired: 'credits retired',
    viewCertificate: 'View certificate',
    viewTxid: 'Wilder Earth - Social Carbon',
    viewBlockExplorer: 'Wilder Explorer — TXID',
    txidCopiedTitle: 'TXID copied',
    txidCopiedMessage:
      'The TXID has been copied to your clipboard. On the explorer page that opened, press Ctrl+V (or Cmd+V on Mac) to paste and search for the transaction.',
    txidCopyFailedTitle: 'Could not copy TXID',
    txidCopyFailedMessage: 'Please try again or copy the TXID manually from the card.',
    dismissToast: 'Got it',
    showMore: 'Show more',
    showLess: 'Show less',
    viewMore: 'View More',
    tryAgain: 'Try again',
    loading: 'Loading retirements...',
    error: 'Error loading retirements',
    noRetirements: 'No retirements available at the moment'
  },
  benefitSharing: {
    eyebrow: 'Transparency',
    title: 'Benefit Sharing',
    subtitle:
      'Distribution of compensation economic benefits among community, Vert Ecotech and project owner.',
    percentChartTitle: 'Percentage distribution',
    creditsChartTitle: 'Distribution in retired credits',
    centerDistribution: 'of distribution',
    totalLabel: 'Total retired',
    creditsUnit: 'credits retired',
    labels: {
      social: 'Social',
      vert: 'Vert Ecotech',
      owner: 'Owner',
    },
    legendAria: 'Benefit sharing legend',
  },
  languageSelector: {
    selectLanguage: 'Select Language',
    clickMap: 'Click on the map to change the language'
  },
  purchaseModal: {
    title: 'Request Credit Purchase',
    packageLabel: 'Credit Package',
    verifyPackage: 'Verify selected package',
    fullName: 'Full Name',
    phone: 'Phone',
    email: 'Email',
    phonePlaceholder: '(11) 99999-9999',
    namePlaceholder: 'Enter your full name',
    emailPlaceholder: 'your@email.com',
    cancel: 'Cancel',
    submit: 'Submit Request',
    submitting: 'Sending...',
    required: '*',
    errors: {
      nameLength: 'Name must be at least 3 characters',
      phoneLength: 'Phone must have 10 or 11 digits',
      emailInvalid: 'Email must be valid',
      formErrors: 'Please correct the errors in the form.'
    },
    success: 'Request sent successfully! We will contact you soon.',
    error: 'Error sending request. Please try again.',
    connectionError: 'Connection error. Check your internet and try again.'
  },
  assetModal: {
    title: 'Credit Package Details',
    assetName: 'Credit Package Name',
    issuer: 'Issuer',
    standard: 'Standard',
    assetType: 'Asset type',
    projectType: 'Project type',
    vintage: 'Vintage',
    serialNumberBatch: 'Serial number batch',
    tokenAddress: 'Token Address',
    txid: 'TXID',
    createdDate: 'Created Date',
    modifiedDate: 'Modified Date',
    createdBy: 'Created by',
    assetId: 'Asset',
    issuanceId: 'Issuance',
    projectId: 'Project',
    registry: 'Registry',
    creditsIssued: 'credits issued',
    purchaseButton: 'Request Credit Purchase',
    loading: 'Loading...',
    error: 'Error loading Credit Package Details',
    noAssetFound: 'No asset found with this name',
    notAvailable: 'N/A',
    viewOnRegistry: 'View on Social Carbon registry',
  },
  b4CarbonSection: {
    originationPeriodLabel: 'Origination period',
    loading: 'Loading projects…',
    tryAgain: 'Try again',
    noPackages: 'No package found for the configured issuer (Vert Ecotech).',
    packageDetails: 'Project details',
    wilderSocialCarbonDetails: 'Wilder Earth — Social Carbon',
    purchaseRequest: 'Request reservation',
    detailsOnRegistry: 'Details available in the registry.',
    showcaseEyebrow: 'DEVELOPED BY VERT ECOTECH',
    showcaseTitle: 'Carbon credit projects',
    loadErrorFallback: 'Failed to load projects',
    impactStandard: 'Standard',
    impactVintage: 'Vintage',
    impactCreditsIssued: 'credits issued',
    impactRegistry: 'Registered',
    defaultAssetType: 'Carbon',
    packageFallbackPrefix: 'Package',
    viewPackageDetailsTitle: 'View project details',
    ctaLearnProject: 'Learn about the project',
    ctaBlockchainRegistry: 'View on Polygonscan — Blockchain registry',
    expandImageAria: 'View full image',
    closeLightbox: 'Close',
    featuredProjects: [
      {
        protocolLogo: 'Protocolo Owie Bitioni - 1.png',
        protocolAlt: 'Owie Bitioni protocol',
        body:
          'The project exists to protect territorial integrity through continuous monitoring and active surveillance, acting directly to preserve biodiversity and maintain ecosystem balance.',
        href: 'https://b4.capital/pt/projeto-owie-bitioni/',
        animalImage: 'Tamandua j crestani.png',
        animalAlt: 'Giant anteater — Owie Bitioni project',
        certificateImage: 'certificado-owie+bitioni.png',
        certificateAlt: 'Owie Bitioni project certificate',
        blockchainRegistryHref:
          'https://polygonscan.com/nft/0xc84fc3cdc3c6d0713ecc6008e50efcffc9b14b3b/1',
      },
      {
        protocolLogo: 'Protocolo Dowedi Mitir Final.png',
        protocolAlt: 'Dowedi Mitir protocol',
        body:
          'The project exists to address the systemic risk of wildfires through an active surveillance strategy, combining monitoring technology and ancestral knowledge to protect the region.',
        href: 'https://b4.capital/pt/projeto-dowedi-mitir/',
        animalImage: 'Cervo do Pantanal Dowedi.png',
        animalAlt: 'Pantanal deer — Dowedi Mitir project',
        certificateImage: 'certificado-Dowedi+Mitir.png',
        certificateAlt: 'Dowedi Mitir project certificate',
        blockchainRegistryHref:
          'https://polygonscan.com/nft/0xfe7dee81b1a416068a5ce01f3489bd5c9996ae62/1',
      },
    ],
  },
  b4VertPage: {
    meta: {
      title: 'Vert Ecotech at B4, Bolsa de Ação Climática | Carbon credits and carbon market',
      description:
        "Vert Ecotech accredited at B4, Bolsa de Ação Climática — Brazil's Climate Action Exchange. Carbon market, carbon credits, transparency and blockchain.",
    },
    nav: {
      home: 'Home',
      about: 'About B4, Bolsa de Ação Climática',
      partnership: 'Ecosystem and accreditation',
      certificate: 'Certificate',
      compliance: 'Compliance',
      projects: 'Carbon projects',
      benefitSharing: 'Benefit Sharing',
      retirements: 'Retirements',
      methodology: 'Methodology and impact',
      docs: 'Resources and documentation',
      contact: 'Contact',
    },
    hero: {
      eyebrow: 'Accredited company',
      titleBefore: 'Vert Ecotech at',
      lead:
        'Connecting sustainable projects to the global carbon market with transparency, technology and real impact.',
      ctaProjects: 'Explore projects',
      ctaPlatform: 'Access B4 platform',
      altSeal: 'B4, Bolsa de Ação Climática seal',
    },
    about: {
      eyebrow: 'Institutional',
      h2: 'About B4, The First Climate Action Exchange',
      body1:
        'B4 was created to reduce greenhouse gas emissions and strengthen the sustainability market through blockchain technology, ensuring traceability and security in transactions.',
      body2:
        'The platform connects sustainable asset originators with companies starting or advancing their climate action journey.',
      btnOfficial: 'Official B4 page',
      trustTitle: 'Trust seal',
      altMini: 'Mini certificate — B4 accreditation',
    },
    partnership: {
      eyebrow: 'company ecosystem at B4, climate action exchange',
      h2: 'Vert Ecotech: Accredited company',
      lead1:
        'Vert Ecotech is an accredited company at B4, acting as a developer of sustainable projects within the ecosystem. This collaboration aims to promote, structure and accelerate the listing of carbon credits, combining technical, environmental and strategic expertise.',
      allowsLead: 'Accreditation enables:',
      cards: [
        {
          title: 'Sustainability project development',
          text: "With Vert Ecotech's expertise, we develop projects that originate carbon credits in formats accepted by B4.",
        },
        {
          title: 'Compliance with B4 accreditation standards',
          text:
            'As a B4-accredited partner, we structure projects aligned with required criteria—reducing friction and improving efficiency through due diligence and listing.',
        },
        {
          title: 'Credibility and trust in the global market',
          text: 'Projects access a global regenerative finance ecosystem, connecting companies and institutions on their climate action journeys.',
        },
      ],
    },
    certificate: {
      eyebrow: 'Recognition',
      h2: 'B4 accredited company certificate',
      body:
        'Official accreditation certificate issued to reinforce the credibility of the company among the ecosystem of enterprises. Accreditation confirms alignment with B4 criteria and supports public consultation of the document, with options to view or validate on the official platform.',
      viewCert: 'View certificate',
      validate: 'Validate on B4',
      vertHomologated: 'Vert accredited on B4',
      altCert: 'B4 accredited company certificate',
    },
    governance: {
      eyebrow: 'Transparency',
      h2: 'Compliance and governance',
      lead: 'Pillars of transparency, credibility and alignment with regulated and voluntary carbon markets.',
      items: [
        {
          title: 'Adherence to B4 standards',
          content:
            'All projects and operations follow carbon market guidelines and rules in both regulated and voluntary settings.',
        },
        {
          title: 'Transparency mechanisms',
          content: 'Vert Ecotech ensures:',
          list: [
            'Blockchain traceability',
            'Independent audits',
            'Public transaction records',
          ],
        },
        {
          title: 'Governance structure',
          content: 'Overview of the internal structure responsible for projects',
        },
      ],
      teams: {
        quemSomosUrl: 'https://vertecotech.io/quem-somos/',
        technicalHeading:
          'Technical team together with the Sustainability Committee',
        technicalMembers: [
          { name: 'André Jardini' },
          { name: 'Caroline Jerke' },
          { name: 'Izabel Melz Fleck' },
        ],
        projectMgmtHeading: 'Project team:',
        projectMgmtLinkLabel: 'About us',
      },
    },
    methodology: {
      eyebrow: 'Impact',
      h2: 'Methodology and impact',
      col1h: 'Methodologies',
      col1items: ['Social Carbon', 'Other standards recognized by the carbon market'],
      col2h: 'Environmental benefits',
      col2items: ['Estimated CO₂ reduction', 'Environmental conservation', 'Sustainable land use'],
      col3h: 'Social and ESG benefits',
      col3items: [
        'Impact on local communities',
        'Job and income generation',
        'Contribution to the UN SDGs (Sustainable Development Goals)',
      ],
    },
    docs: {
      eyebrow: 'Access',
      h2: 'Resources and documentation',
      accessBtn: 'Open',
      placeholderDriveSuffix: '— Briefing: Google Drive folder',
      placeholderLink: 'Add external link or PDF',
      linkTitles: {
        creditVerification: 'Wilder Earth Registry',
        platformAccess: 'B4 platform access',
        vertHomologated: 'Vert Ecotech accredited on B4',
        projectsListed: 'Projects listed on B4',
        blockchain: 'Wilder Earth Blockchain Explorer',
      },
    },
    contact: {
      eyebrow: 'Get in touch',
      h2: 'Contact',
      lead:
        'Reach the Vert Ecotech team — carbon credits, carbon market and partnership with B4, Bolsa de Ação Climática.',
      mailSubject: 'B4, Bolsa de Ação Climática / Carbon credits',
      namePh: 'Name',
      emailPh: 'Email',
      messagePh: 'Message',
      submit: 'Send message',
      sending: 'Sending…',
      successTitle: 'Message sent!',
      successText:
        'We received your message and our team will get back to you as soon as possible.',
      sendAnother: 'Send another message',
      mailBodyName: 'Name: ',
      mailBodyEmail: 'Email: ',
      errors: {
        nome: 'Please enter your name.',
        email: 'Please enter your email.',
        mensagem: 'Please describe your question or issue.',
        mensagemLong: 'Message too long (max 10,000 characters).',
        rateLimit: 'Too many attempts. Please wait a moment and try again.',
        general: 'Could not send your message. Please try again.',
        connection: 'Could not connect to the server.',
      },
    },
    footer: {
      climateExchange: "Brazil's Climate Action Exchange",
      top: 'Top',
      legacyRef: 'Legacy reference (API)',
    },
  },
  b4CertificatePage: {
    meta: {
      title: 'Certificate Vert Ecotech accredited at B4, Bolsa de Ação Climática | Carbon market',
      description:
        'B4, Bolsa de Ação Climática company accreditation certificate. Validate status on the official platform.',
    },
    backLink: '← Vert Ecotech · B4, Bolsa de Ação Climática',
    h1Before: 'Company certificate accredited at',
    h1Gradient: 'B4',
    lead:
      'Official B4, Bolsa de Ação Climática accreditation document for the selected language. Download the PNG below.',
    previewLabel: 'Certificate — preview',
    altCert: 'B4 accredited company certificate',
    bodyValidation:
      'Public validation of status can be done on the B4 platform, ensuring authenticity and transparency.',
    downloadLabel: 'Download — PNG',
    downloadFile: 'Certificado-Vert-B4-EN.png',
    downloadBtn: 'Download certificate',
    officialSite: 'Official B4 site',
    aboutH2: 'About accreditation',
    aboutBody:
      'Accreditation confirms that the company meets the operational and compliance requirements defined by B4, Bolsa de Ação Climática for activity on the platform, including audit trails and governance aligned with the carbon credit market.',
    footerBack: 'Back to B4, Bolsa de Ação Climática / Vert Ecotech page',
  },
};

